export interface SignedDocument {
    id: number;
    type: SignedDocumentType;
    documentName: string;
    filePath: string;
    fileSize?: number;
    contentType?: string;
    signedAt: string;
    createdAt: string;
    signerName?: string;
    companyName: string;
    contractId?: number;
    contractNumber?: string;
    hasSignature: boolean;
    contractStatus?: string;
}

export enum SignedDocumentType {
    CONTRACT = 'CONTRACT',
    AVR = 'AVR',
    PURCHASE_REQUEST = 'PURCHASE_REQUEST'
}

export interface SignedDocumentResponse {
    documents: SignedDocument[];
    total: number;
}

export interface DocumentStatistics {
    totalDocuments: number;
    contractsCount: number;
    avrCount: number;
    purchaseRequestsCount: number;
}

export interface DocumentDownloadResponse {
    downloadUrl: string;
}

export interface DocumentTypesResponse {
    types: Record<string, string>;
}
